export default {
  nav: {
    logo_text: "Dong Thap Fruit Festival",
    home: "Home",
    products: "Products",
    schedule: "Schedule",
    change_language: "Change Language",
    organization: "Dong Thap Digital Transformation Center",
  },
  home: {
    banner: {
      annual_event: "Annual Event 2026",
      title: "Dong Thap Fruit Flavors Connecting & Reaching Far",
      description:
        "Honoring the value of agricultural products and the beauty of Dong Thap orchards through a colorful festival space of specialty fruits.",
      view_schedule: "View Schedule",
      explore_products: "Explore Products",
    },
    about: {
      subtitle: "FESTIVAL INTRODUCTION",
      theme: "Theme",
      time: "Time",
      scale: "Scale",
      location: "Location",
    },
    products: {
      title: "Featured Fruits",
      subtitle:
        "Enjoy the sweet and fresh flavors from the largest specialized fruit cultivation areas of the Pink Lotus Land.",
      dong_thap_specialty: "Dong Thap Specialty",
      specialty_fruit: "Specialty Fruit",
      ocop_dong_thap: "Dong Thap OCOP",
      view_all: "View All Products",
    },
    schedule: {
      title: "Featured Events Schedule",
      desc: "Outstanding activities within the framework of the Dong Thap Fruit Festival 2026.",
      all_events: "All Events",
      location: "Location",
      main_activity: "Main Activity",
      focus: "Focus",
      host: "Host",
      delegates: "Delegates",
      advise: "Advise",
      collaborate: "Collaborate",
      cooperate: "Cooperate",
      content: "Detailed Activity Content",
      detail_content: "Detailed content",
      show_details: "View Details",
      hide_details: "Collapse",
      supporting_activity: "Supporting Activity",
      response: "Responding",
      day: "Day",
      month: "Month",
      host_unit: "Host unit",
      cooperating_unit: "Cooperating unit",
      support_detail: "Supporting program details",
    },
    tabs: {
      khungGio: "Hourly Schedule",
      xuyenSuot: "Ongoing Activities",
      chinh: "Main Activities",
      huongUng: "Supporting Activities",
    },
  },
  catalog: {
    lotus_land: "Pink Lotus Land",
    title: "Specialty Fruit Catalog",
    description:
      "Dong Thap – The land of Pink Lotus, famous for its specialty fruits enriched by fertile alluvial soil. We are proud to introduce a diverse fruit ecosystem meeting high-quality standards and international certifications.",
    search_placeholder: "Search for specialty fruits...",
    loading: "Loading fruit catalog...",
    empty_message: "No matching fruit products found.",
    reset_filters: "Reset filters",
    certified: "Certified",
    growing_zone: "Growing Zone",
    growing_zone_text: "Growing zone",
    view_detail: "View Detail",
  },
  detail: {
    back_to_list: "Back to list",
    specialty_category: "Specialty fruit category",
    certified_specialty: "Certified specialty",
    area: "Area",
    yield: "Yield",
    updating_images: "Updating images",
    bio_characteristics: "Biological characteristics",
    char_desc: "Characteristic description",
    cert_protection: "Certification & Protection",
    qr_view_info: "QR Code for details",
    traceability_code: "Traceability Code",
    qr_desc: "Share this QR code to view specialty fruit information",
    code_label: "Code:",
    concentrated_area: "Concentrated growing area",
    attached_documents: "Attached documents",
    click_to_enlarge: "Click to enlarge photo",
    orchard_photos: "Orchard photos",
    orchard_photo: "Orchard photo",
    updating: "Updating",
    export_market: "Export Market",
    market: "Market",
    export_status: "Export Info / Status",
    flag: "Flag",
    infographic_title: "Product Infographics",
    infographic_subtitle:
      "Visual representation of standards and processes for specialty fruit",
    click_to_zoom: "Click to view full size",
  },
  schedule_page: {
    green_journey: "GREEN JOURNEY 2026",
    hero_title: "DONG THAP FRUIT FESTIVAL 2026 ACTIVITIES PROGRAM",
    hero_desc:
      "Discover outstanding events honoring agricultural products and the culture of the Pink Lotus land within the framework of the biggest festival of the year.",
    empty_state: "Updating the activities list for this category...",
    important: "Important",
    location: "Location",
    organizer: "Host / Advising Unit",
    partner: "Collaborate",
    scale: "Scale",
    concept: "Idea",
    format: "Format",
    details: "Detailed activity content",
    ongoing_duration: "Throughout the Festival",
    all_day: "All day",
    update_error: "Error loading activities list:",
    no_attachment: "No attachment found for activity:",
    more_updates: "More schedule updates from the Organizer are coming soon.",
  },
};
